<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="6" class="py-2">
                <span><b>Comment Details : </b>{{text}}</span>
              </b-col>
              
              <b-col cols="12" md="6" class="py-2 text-right">
                <b-button variant="outline-primary" size="sm" class="mr-1"  @click="confirmBox"
                  >Mark as Genuine Comment</b-button
                >

                <b-button variant="outline-danger"  size="sm" @click="spamconfirmBox"
                  >Mark as Spam</b-button
                >
                <b-button variant="link"  @click="previous()">  <i
                v-if="previousIcon"
                class="fa fa-chevron-left pr-4"
                style="color: blue"
               
                aria-hidden="true"
              ></i></b-button>
            <b-button variant="link" @click="next()">  <i
                v-if="nextIcon"
                class="fa fa-chevron-right"
                style="color: blue"
                @click="next()"
                aria-hidden="true"
              ></i></b-button>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="CommentReport"
            :fields="fields"
          >
            <template slot="createddate" slot-scope="data">
              <span v-if="data.item.createddate">{{
                formatDt(data.item.createddate)
              }}</span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="text" slot-scope="data">
              <span v-if="data.item.text">{{ data.item.text }}</span>
              <span v-else>-</span>
            </template> -->
            <template slot="reportedby" slot-scope="data">
              <span v-if="data.item.user">{{ data.item.user.name }}</span>
              <span v-else>-</span>
            </template>
           
          </b-table>
          <!-- <nav>
            <b-pagination
              size="sm"
              :total-rows="discussions.length"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            />
          </nav> -->
         
        </b-card>
      </transition>
      <b-card no-header height="100%">
        <!-- <template slot="header">
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="12" md="6">
                  <span></span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template> -->
        <div v-if="fullReport" ref="msgscreen">
          <b-row class="justify-content-md-center scroll_container ">
            <b-col cols="12" md="10" text-right>
              <b-row v-for="(item, i) in fullReport" :key="i" :id="'msgno' + i">
                <b-col
                  v-if="
                    i > 0 &&
                    formatDate(item.createdAt) !=
                      formatDate(fullReport[i - 1].createdAt)
                  "
                  class="pb-2"
                  cols="12"
                  md="12"
                  align="center"
                  ><b-badge variant="light">{{
                    formatDate(item.createdAt)
                  }}</b-badge>
                </b-col>
                <b-col
                  v-if="i == 0"
                  class="pb-2"
                  cols="12"
                  md="12"
                  align="center"
                >
                  <b-badge variant="light">{{
                    formatDate(item.createdAt)
                  }}</b-badge>
                </b-col>
                <b-col v-if="item.user._id != usrId" cols="12" md="6">
                  

                  <b-card v-if="item.isanonymous" sub-title="Anonymous">
                    <b-card-text>
                      {{ item.text }}
                      <b-row class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                  <b-card v-else-if="(item.isanonymous == true) && (item._id == commentID)"  border-variant="danger" sub-title="Anonymous">
                    <b-card-text>
                      {{ item.text }}
                      <b-row class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                  <b-card v-else-if=" (item._id == commentID)"  border-variant="danger" :sub-title="item.user.name">
                    <b-card-text>
                      {{ item.text }}
                      <b-row dense class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                  <b-card v-else :sub-title="item.user.name">
                    <b-card-text>
                      {{ item.text }}
                      <b-row dense class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
                <b-col v-else md="6" offset-md="6 ">
                 
                  <b-card v-if=" (item._id == commentID)"  border-variant="danger">
                    <b-card-text>
                      {{ item.text }}
                      <b-row class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                  <b-card v-else>
                    <b-card-text>
                      {{ item.text }}
                      <b-row class="justify-content-md-end">
                        <b-col cols="12" md="4" style="color: grey" align="end">
                          {{ formatTime(item.createdAt) }}
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form @submit.prevent="sendMssg">
                <b-input-group>
                  <b-form-input
                    v-model="message"
                    type="text"
                    id="message"
                    placeholder="Type a message"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      text="Button"
                      variant="outline-primary"
                      @click="sendMssg"
                    >
                      <i class="fa fa-send" aria-hidden="true"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </b-col>
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";

export default {
  props: ["Incid", "commentID","idset","idset1"],
  data() {
    return {
      fullReport: null,
      previousIcon: true,
      nextIcon: true,
      CommentReport: [],
      discussion: null,
      user: null,
      id:null,
      text:null,
      appLoading: false,
      id: null,
      ServerError: false,
      superAdmin: false,
      message: null,
      usrId: null,
      mine: [],
      others: [],
      chat: null,
      fields: [
        { key: "reportedby", label: "Reported By", sortable: true },
        { key: "comment", label: "Comment", sortable: true },
        { key: "createddate", label: "Reported On", sortable: true },
      ],
    };
  },
  mounted() {
    this.getProfile();
    // console.log(this.idset1)
    this.$socket.emit("auth", {
      token: localStorage.getItem("token"),
      incident: this.Incid,
    });
    this.sockets.subscribe("new_comment", (response) => {
      if (response) {
        // this.getData();

        this.fullReport.push(response)
        //  console.log(this.fullReport)
      }
    });
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
    formatTime(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    //this.socket.join("new_comment", {
    //   token: localStorage.getItem("token"),
    //   incident: this.$route.params.id,
    // });
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.usrId = response.data.data._id;
          this.getComment();
          this.getData();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    next() {
      // alert(this.idset)
      var temp = [];
      var temp1 = [];
      temp = this.idset.split(",");
      temp1 = this.idset1.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          this.$router.push("/Discussions/" +temp1[j+1]+'/'+ temp[j + 1] + "/" + temp +'/'+temp1);
          this.getProfile();
        }
      }
    },
    previous() {
      var temp = [];
      var temp1 = [];
      temp = this.idset.split(",");
      temp1 = this.idset1.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          if (j != 0) {
           this.$router.push("/Discussions/" +temp1[j-1]+'/'+ temp[j - 1] + "/" + temp +'/'+temp1);
            this.getProfile();
          }
        }
      }
    },
    getData() {
      this.appLoading = false;
      axios({
        method: "GET",
        url: "/discussion/getlist",
        params: {
          incident: this.Incid,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var id
          
          this.fullReport = response.data.data;
          
          // this.$refs.msgscreen.scrollTop=this.$refs.msgscreen.scrollHeight;
          //  $('.scroll_container').scrollTop($('.scroll_container')[0].scrollHeight);
          // window.scrollTo(0,document.getElementById('msgscreen').scrollHeight)
          // for (var i = 0; i < this.fullReport.length; i++) {
          //   if (this.fullReport[i].user._id == this.usrId)
          //     this.mine.push(this.fullReport[i]);
          //   else this.others.push(this.fullReport[i]);
          // }
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    getComment() {
      this.appLoading = false;
      axios({
        method: "GET",
        url: "/discussion/getreportedcomment",
        params: {
          id: this.commentID,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.text = response.data.data.text;
        
          this.CommentReport = response.data.data.reports;
   
          this.id = response.data.data._id
         
          var temp = [];
          temp = this.idset.split(",");
          if ( this.id == temp[0]) {
            this.previousIcon = false;
          } else this.previousIcon = true;
          if (this.id == temp[temp.length - 1]) {
            this.nextIcon = false;
          } else this.nextIcon = true;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    sendMssg() {
      this.appLoading = false;
      axios({
        method: "POST",
        url: "/discussion/add",
        data: {
          incident: this.Incid,
          text: this.message,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.getData();
          this.message = null;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
     spamconfirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to mark this comment  as spam.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.markSpam();
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    markSpam() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/discussion/remove",
        data: {
          id: this.commentID,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to remove from spam list.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.notSpam();
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    notSpam() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/discussion/notspam",
        data: {
          id: this.commentID,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDt(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style>
.scroll_container {
  max-height: 400px;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  /* display: flex;
  flex-direction: column-reverse; */
}
.scroll_container::-webkit-scrollbar {
  /* WebKit */
  width: 0px;
}
</style>